import { Directive } from '@angular/core';

@Directive({
    selector: '[dshBaseDialogTitle]',
})
export class BaseDialogTitleDirective {}
